import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as Papa from 'papaparse';
import { FileUpload } from 'primeng/fileupload';
import { AuthService } from 'src/app/auth.service';
import { BULK_PAY_APPROVALS, BULK_PAY_HISTORY } from 'src/app/routes';
import Utils from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../../loader.service';
import { AlertDialogService } from '../../shared/alert-dialog/alert-dialog.service';
import { BulkPayArrayFields, BulkPayService } from '../bulkpay.service';
var BulkPayInitiateComponent = /** @class */ (function () {
    function BulkPayInitiateComponent(bulkPayService, loaderService, alertDialogService, authService, router) {
        this.bulkPayService = bulkPayService;
        this.loaderService = loaderService;
        this.alertDialogService = alertDialogService;
        this.authService = authService;
        this.router = router;
        this.validated = null;
        this.validationError = false;
        this.fileDetails = null;
        this.maxTransactions = environment.maxBulkPayTransactionsPerFile;
        this.userAccess = [];
        this.enabledTransactionTypes = [];
        this.bulkPayFormGroup = new FormGroup({
            subTransactionType: new FormControl(null, Validators.required),
            comment: new FormControl(null, Validators.required),
            remark: new FormControl(null, [Validators.required, Validators.minLength(1)]),
        });
    }
    BulkPayInitiateComponent.prototype.resetFile = function () {
        this.fileDetails = null;
        this.validated = null;
        this.validationError = false;
    };
    ;
    BulkPayInitiateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.refreshEnabledTransactionTypes();
        this.authService.getUserDetails().subscribe(function (user) {
            _this.userAccess = (user && user.permissions) || [];
            _this.refreshEnabledTransactionTypes();
        });
        this.resetOnchangeOf("subTransactionType", ["remark"], function () {
            _this.fileUploadRef && _this.fileUploadRef.clear();
            _this.resetFile();
        });
    };
    BulkPayInitiateComponent.prototype.selectedSubTransactionType = function () {
        return this.bulkPayFormGroup.get("subTransactionType").value;
    };
    BulkPayInitiateComponent.prototype.allowsCustomRemark = function () {
        var type = this.selectedSubTransactionType();
        return !!(type && (!type.remarks || type.remarks.length === 0));
    };
    BulkPayInitiateComponent.prototype.refreshEnabledTransactionTypes = function () {
        var _this = this;
        this.enabledTransactionTypes = this.bulkPayService.transactionTypes
            .filter(function (t) { return !t.disabled && _this.hasRequiredRole(t); });
        var selected = this.selectedSubTransactionType();
        if (selected && !this.enabledTransactionTypes.some(function (t) { return t.name === selected.name; })) {
            this.bulkPayFormGroup.get('subTransactionType').setValue(null);
        }
    };
    BulkPayInitiateComponent.prototype.hasRequiredRole = function (type) {
        var _this = this;
        // Legacy types omit `roles` and stay visible to everyone.
        // Types with a `roles` array (incl. empty) are shown only to matching users.
        // Values are permission keys (user.permissions).
        if (type.roles == null) {
            return true;
        }
        if (type.roles.length === 0) {
            return false;
        }
        return type.roles.some(function (role) { return _this.userAccess.includes(role); });
    };
    BulkPayInitiateComponent.prototype.resetOnchangeOf = function (controlName, toReset, cb) {
        var _this = this;
        if (cb === void 0) { cb = function () { }; }
        this.bulkPayFormGroup.get(controlName).valueChanges.subscribe(function () {
            toReset.forEach(function (control) {
                _this.bulkPayFormGroup.get(control).setValue(null);
            });
            cb();
        });
    };
    BulkPayInitiateComponent.prototype.handleFile = function (event) {
        var _this = this;
        this.validated = null;
        var file = event.files[0];
        this.resetFile();
        Papa.parse(file, {
            complete: function (results) {
                _this.fileDetails = { records: results.data, name: file.name };
            },
            header: true,
            skipEmptyLines: true,
            transformHeader: function (header) { return header.trim(); },
            transform: function (value, header) { return _this.parseCSVValue(value, header); },
        });
    };
    BulkPayInitiateComponent.prototype.parseCSVValue = function (value, header) {
        if (BulkPayArrayFields.includes(header)) {
            return value.split("|")
                .map(function (v) { return v.trim(); });
        }
        return value.trim();
    };
    BulkPayInitiateComponent.prototype.downloadSampleFile = function () {
        var subTransactionType = this.selectedSubTransactionType();
        if (!subTransactionType) {
            return;
        }
        Utils.downloadCSVFile({
            fields: subTransactionType.headers,
            data: subTransactionType.sampleData,
            fileName: subTransactionType.name.toLowerCase() + ".csv",
        });
    };
    BulkPayInitiateComponent.prototype.showAlertBox = function (options, cb) {
        if (cb === void 0) { cb = function () { }; }
        this.alertDialogService.open(options);
        this.alertDialogService.confirmed()
            .subscribe(function (confirmed) { return confirmed && cb(); });
    };
    BulkPayInitiateComponent.prototype.validateBulkPayFile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var valid, _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        valid = this.validateTransactionCount();
                        if (!valid) {
                            return [2 /*return*/];
                        }
                        this.loaderService.openLoading();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.bulkPayService
                                .validateBulkPayFile(this.bulkPayRequest())];
                    case 2:
                        _a.validated = _b.sent();
                        this.showAlertBox({
                            title: 'Success',
                            message: 'File validation successful.',
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        this.handleError(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BulkPayInitiateComponent.prototype.validateTransactionCount = function () {
        var transactions = this.fileDetails.records;
        var count = transactions.length;
        if (count > this.maxTransactions) {
            this.showAlertBox({
                title: 'Error',
                message: "You can only upload " + this.maxTransactions + " transactions at a time.",
            });
            return false;
        }
        return true;
    };
    BulkPayInitiateComponent.prototype.confirmBulkPayInitiate = function () {
        var _this = this;
        if (new Blob([JSON.stringify(this.bulkPayRequest())]).size > 12 << 20) {
            this.showAlertBox({
                title: 'Error',
                message: 'bulk pay file is too large to submit for approval',
            });
            return;
        }
        var subTransactionType = this.selectedSubTransactionType();
        var message = "You are about to credit \u20B9" + this.validated.totalAmount + " to " + this.validated.transactionsCount + " captains. Do you want to proceed?";
        if (subTransactionType.type == "debit") {
            message = "You are about to debit \u20B9" + Math.abs(this.validated.totalAmount) + " from " + this.validated.transactionsCount + " captains. Do you want to proceed?";
        }
        this.showAlertBox({
            title: 'Confirm',
            message: message,
            confirmText: 'Yes, proceed',
        }, function () { return _this.initiateBulkPay(); });
    };
    BulkPayInitiateComponent.prototype.initiateBulkPay = function () {
        var _this = this;
        this.loaderService.openLoading();
        this.bulkPayService
            .initiateBulkPay(this.bulkPayRequest())
            .then(function (res) {
            if (res && res.autoApproved === false) {
                _this.showAlertBox({
                    title: 'Submitted for approval',
                    message: res.message || 'Bulk payment submitted for approval. It will run after a checker approves it.',
                    confirmText: 'View approvals',
                }, function () { return _this.router.navigateByUrl(BULK_PAY_APPROVALS); });
                return;
            }
            _this.showAlertBox({
                title: 'Success',
                message: 'Bulk pay initiated successfully.',
                confirmText: 'View history',
            }, function () { return _this.gotoHistoryPage(); });
        })
            .catch(function (err) { return _this.handleError(err); })
            .finally(function () { return _this.loaderService.closeLoading(); });
    };
    BulkPayInitiateComponent.prototype.gotoHistoryPage = function () {
        this.router.navigateByUrl(BULK_PAY_HISTORY);
    };
    BulkPayInitiateComponent.prototype.bulkPayRequest = function () {
        var subTransactionType = this.selectedSubTransactionType();
        return {
            subTransactionType: subTransactionType.name,
            remarks: this.bulkPayFormGroup.get("remark").value,
            comment: this.bulkPayFormGroup.get("comment").value,
            transactions: this.fileDetails.records,
        };
    };
    BulkPayInitiateComponent.prototype.handleError = function (err) {
        var unknownErr = "Unknown error, Please check history to get latest status of your file.";
        var res = err.error || { message: unknownErr };
        if (!res.data) {
            this.showAlertBox({
                title: 'Error',
                message: res.message,
            });
            return;
        }
        var data = res.data;
        if (data.code && data.code == "BULK_PAY_VALIDATION_ERROR") {
            this.validationError = true;
            var errors = data.errors;
            var value = errors
                .map(function (err) { return "Record: " + err.recordNumber + " - " + err.error; });
            this.showAlertBox({
                title: 'Validation Error',
                details: [
                    {
                        value: value,
                        message: "Please correct the errors and try again."
                    }
                ],
            });
            return;
        }
        var error = data.error || data;
        this.showAlertBox({
            title: 'Error',
            message: error.message || unknownErr,
        });
    };
    return BulkPayInitiateComponent;
}());
export { BulkPayInitiateComponent };
